import {
  MAINTENANCE_PREVIEW_SCREENS_WITH_CONSOLE,
  type MaintenancePreviewScreen,
} from '../lib/maintenancePreviewRegistry';
import { MaintenancePreviewMountContext } from '../lib/maintenancePreviewMountContext';

export { MAINTENANCE_PREVIEW_SCREENS_WITH_CONSOLE as MASTER_ADMIN_PREVIEW_SCREENS };

interface MasterAdminScreenMountProps {
  screenId: string;
}

function resolvePreviewScreen(screenId: string): MaintenancePreviewScreen {
  return MAINTENANCE_PREVIEW_SCREENS_WITH_CONSOLE.find((item) => item.screenId === screenId)
    ?? MAINTENANCE_PREVIEW_SCREENS_WITH_CONSOLE[0];
}

/** Embeds an MPL screen inside MPL-11 without nesting a second React Router. */
export default function MasterAdminScreenMount({ screenId }: MasterAdminScreenMountProps) {
  const screen = resolvePreviewScreen(screenId);
  const { Component } = screen;

  return (
    <MaintenancePreviewMountContext.Provider
      value={{ active: true, screenId, route: screen.route }}
    >
      <div
        className="master-admin-screen-mount maintenance-embed-preview"
        data-preview-screen={screenId}
        data-preview-route={screen.route}
      >
        <Component />
      </div>
    </MaintenancePreviewMountContext.Provider>
  );
}
